import { io } from "socket.io-client";

// Connect to the backend socket server
const socket = io("https://backend.gouniquejourneys.co.uk", {
  transports: ["websocket", "polling"]
});

export default socket;
